/* eslint-disable react-hooks/rules-of-hooks */
import { useCallback } from 'react'
import {
  useGoToPathFactory,
  useCreateHrefFactory,
} from '../core/factories/routing/routingHooks.factories'
import { useCoreContext } from '../core/RPPCoreContext'
import { url } from '../parsing/url'
import { type RouteName } from './routes'

export const useGoToPath = useGoToPathFactory<RouteName>()
export const useCreateHref = useCreateHrefFactory<RouteName>()

export const useNavigateTo = routeName => {
  const { routesByName } = useCoreContext()

  // Should only be used when we want to change paths as well
  // as force a refetch of all state.
  const navigate = useCallback(() => {
    const path = url(routesByName[routeName])
    window.location.href = path
  }, [routeName, routesByName])

  return navigate
}

export const useNavigateToPath = path => {
  // Should only be used when we want to change paths as well
  // as force a refetch of all state.
  const navigate = useCallback(() => {
    window.location.href = path
  }, [path])

  return navigate
}
